import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  isTimeout: false
}

export const timeoutSlice = createSlice({
  name: 'timeout',
  initialState,
  reducers: {
    setIsTimeout: (state, action) => {
      state.isTimeout = action.payload
    },
    resetTimeout: () => initialState
  }
})

export const {setIsTimeout, resetTimeout} = timeoutSlice.actions

// Selectors
export const selectIsTimeout = (state) => state.timeout.isTimeout

export default timeoutSlice.reducer
